const productionApiUrl = "https://backend.orgin3.com/api";
const developmentApiUrl = "http://localhost:5000/api";

export const mainurl =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "development"
    ? developmentApiUrl
    : productionApiUrl);
